module.exports = __webpack_public_path__ + "static/media/iPhone14_4.77619276.png";